import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AvailabilityBanner from "@/components/AvailabilityBanner";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import Gallery from "@/components/Gallery";
import LeadMagnet from "@/components/LeadMagnet";
import Testimonials from "@/components/Testimonials";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import Login from "@/components/Login";
import ResetPassword from "@/components/ResetPassword";
import AdminDashboard from "@/components/AdminDashboard";
import ServiceLanding from "@/components/ServiceLanding";
import { Toaster } from "sonner";

// Main Landing Page Component
const LandingPage = () => {
  return (
    <div data-testid="landing-page-container" className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <Hero />
      <AvailabilityBanner />
      <About />
      <Services />
      <WhyChooseUs />
      <Gallery />
      <LeadMagnet />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App bg-[#0A0A0A] text-white min-h-screen">
        <BrowserRouter>
          <Routes>
            {/* Public Landing Page Route */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Admin Login Route */}
            <Route path="/login" element={<Login />} />
            
            {/* Reset Password Route */}
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* SEO Landing Pages per service */}
            <Route path="/nunti" element={<ServiceLanding />} />
            <Route path="/botezuri" element={<ServiceLanding />} />
            <Route path="/cununii" element={<ServiceLanding />} />
            <Route path="/evenimente-corporate" element={<ServiceLanding />} />
            <Route path="/aniversari" element={<ServiceLanding />} />
            <Route path="/petreceri-private" element={<ServiceLanding />} />

            {/* Protected Admin Panel Route */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />

            {/* Catch-all Route redirects to Landing */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" closeButton richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
